module.exports = __webpack_public_path__ + "media/contract/LabelArrow-a1711968.png";